import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";

export const useTracking = () => {
  const trackClick = (urlAlias: string, entityId: string, index: string) => {
    sendGATracking({
      action: "More on this Story/Click",
      category: "More on this Story",
      label: urlAlias,
    });
    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        article_id: entityId,
        article_seq: index,
        destination_url: urlAlias,
        page_type: "article",
        widget_name: "read_more",
      },
      subcategory: "widget",
    });
  };

  return {
    trackClick,
  };
};
